/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const CakeIconOutline = createIcon({
  displayName: 'CakeIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M0,0H24V24H0Z" fill="none" />
      <path
        d="M3,11.75A2.25,2.25,0,0,0,5.25,14h0a2.243,2.243,0,0,0,1.591-.659.95214.95214,0,0,1,1.318,0A2.243,2.243,0,0,0,9.75,14h0a2.243,2.243,0,0,0,1.591-.659.95214.95214,0,0,1,1.318,0A2.243,2.243,0,0,0,14.25,14h0a2.243,2.243,0,0,0,1.591-.659.95214.95214,0,0,1,1.318,0A2.243,2.243,0,0,0,18.75,14h0A2.25,2.25,0,0,0,21,11.75h0A2.75,2.75,0,0,0,18.25,9H5.75A2.75,2.75,0,0,0,3,11.75Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="22"
        y1="21"
        x2="2"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="7.00007"
        y1="9.00022"
        x2="7.00007"
        y2="7.00012"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="17.00007"
        y1="9.00022"
        x2="17.00007"
        y2="7.00012"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="12.00007"
        y1="9.00022"
        x2="12.00007"
        y2="7.00012"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line x1="7" y1="4" x2="7" y2="3" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <line
        x1="12"
        y1="4"
        x2="12"
        y2="3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="17"
        y1="4"
        x2="17"
        y2="3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="20"
        y1="17.5"
        x2="4"
        y2="17.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="20"
        y1="21"
        x2="20"
        y2="13.92857"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="4"
        y1="21"
        x2="4"
        y2="13.92857"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const Cake: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    default:
      return <CustomIcon as={CakeIconOutline} {...props} />
  }
}

export default memo(Cake)
